export const InfoCard = ({ icon, title, subtitle, accent }) => (
  <div className="bg-white/5 rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition">
    <div
      className={`p-3 bg-${accent}-500/20 text-${accent}-400 rounded-xl w-16 h-16 flex items-center justify-center mx-auto mb-4`}
    >
      {icon}
    </div>
    <div className="text-lg font-semibold text-white mb-1">{title}</div>
    <div className="text-sm text-gray-400">{subtitle}</div>
  </div>
);